/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
  initCarousel()
  initAnimate()
  initNav()
})

function initCarousel () {
  let carousel = $('.owl-carousel')

  carousel.on({
    'initialized.owl.carousel': async (event) => {
      let current = event.item.index
      var notActiveItem = $(event.target).find(".owl-item").eq(current).siblings()

      carousel.removeClass('.kv-placeholder')

      await new Promise(resolve => setTimeout(resolve, 1000))
      
      notActiveItem.find('.aos-init').each(function() {
        $(this).removeClass('aos-animate')
      })
    },
    'changed.owl.carousel': function (property) {
      let current = property.item.index
      var activeItem = $(property.target).find(".owl-item").eq(current)

      activeItem.find('.aos-init').each(function() {
        $(this).addClass('aos-animate')
      })

      activeItem.siblings().find('.aos-init').each(function() {
        $(this).removeClass('aos-animate')
      })
    },
  })

	carousel.each(function () {
		const options = $(this).data('options')
    const $this = $(this)

		$this.owlCarousel({
			...options,
			onInitialized: startProgressBar,
			onTranslate: resetProgressBar,
			onTranslated: startProgressBar,
			navText: [
        '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.6px" height="15.5px" viewBox="0 0 40.6 15.5" style="overflow:visible;enable-background:new 0 0 40.6 15.5;" xml:space="preserve"><polyline class="color" style="fill:none;stroke-miterlimit:10;" points="0.3,15.1 20.3,0.6 40.3,15.1" stroke="white"></polyline></svg>',
        
        '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.6px" height="15.5px" viewBox="0 0 40.6 15.5" style="overflow:visible;enable-background:new 0 0 40.6 15.5;" xml:space="preserve"><polyline class="color" style="fill:none;stroke-miterlimit:10;" points="0.3,15.1 20.3,0.6 40.3,15.1" stroke="white"></polyline></svg>'
      ],
		})
	})
}

function startProgressBar() {
  // apply keyframe animation
  $(".kv-carousel-progress span").css({
    width: "100%",
    transition: "width 6000ms"
  });
}

function resetProgressBar() {
  $(".kv-carousel-progress span").css({
    width: 0,
    transition: "width 0s"
  });
}

function initAnimate() {
  $(`
    .block-title,
    .block-subtitle,
    .product-name,
    .product-cta,
    .block-feature .badge,
    .block-feature-point,
    .block-perfume-instruction .perfume-subtitle,
    .block-perfume-instruction .perfume-person
  `).each(function () {
		$(this).attr({
			'data-aos': 'fade-down',
		})
	})

  $(`
    .product-info,
    .block-feature-circle .h5,
    .block-feature .col-xl-7 p,
    .block-perfume .product-image
  `).each(function () {
		$(this).attr({
			'data-aos': 'fade-in',
			'data-aos-delay': 200,
		})
	})

  $(`
    .perfume-smell,
    .perfume-type
  `).each(function () {
		$(this).attr({
			'data-aos': 'fade-up',
		})
	})

  AOS.init({
		duration: 1000,
		// once: true,
	})
}

function initNav() {
  // var navModalEl = document.querySelector('#navModal')
  // var navModal = bootstrap.Modal.getOrCreateInstance(navModalEl)

  $('.modal-nav .nav-link').on('click', function () {
    $('.modal-nav').removeClass('show').attr({
      'aria-hidden': 'true',
      'style': 'display: none',
    }).removeAttr('aria-modal role');
    $('body').removeClass('modal-open').removeAttr('style', '');
    $('.modal-backdrop').remove();

    setTimeout(() => {
      $('.navbar-toggler').click();
    }, 1000) 
  })
}
